import React, {useMemo} from "react"
import PropTypes from "prop-types"

import DataGridTable from "src/v2/components/Table/data-grid-table"
import { getColumnsTableEmissao  } from "./emission-table-const"

import {useNavigate} from "react-router-dom"
import {EMISSAO_V2_PAGE} from "src/utils/routes"

const EmissionTable = ({
    data = [],
    loading = false,
    isAdminUser = false,
}) => {
    const navigate = useNavigate()

    const handleRowClick = ({row}) => {
        if (!row?.RendaFixaCaracteristicasID || !row?.CETIP) return

        navigate(EMISSAO_V2_PAGE, {
            state: {
                cetip: row.CETIP,
                versaoDocumento: row.VersaoDocumento,
                id: row.RendaFixaCaracteristicasID,
            },
        })
    }

    const columns = useMemo(
        () => getColumnsTableEmissao(isAdminUser),
        [isAdminUser]
    )

    return (
        <DataGridTable
            rows={data}
            columns={columns}
            loading={loading}
            disableDeleteColumn
            pageSize={25}
            getRowId={(row) => row.RendaFixaCaracteristicasID}
            onRowClick={handleRowClick}
        />
    )
}

EmissionTable.propTypes = {
    data: PropTypes.arrayOf(
        PropTypes.object
    ).isRequired,
    loading: PropTypes.bool,
    isAdminUser: PropTypes.bool,
}

export default EmissionTable